// Domain-to-API mapping: when the frontend is served from a domain,
// route API/WS calls to the matching API subdomain so auth cookies
// stay same-site (SameSite=Lax works across subdomains of the same
// registrable domain).
const DOMAIN_API_MAP: Record<string, { api: string; ws: string }> = {
  'app.thetradespy.ai': {
    api: 'https://api.thetradespy.ai',
    ws: 'wss://api.thetradespy.ai',
  },
  'tonydev.iremedy.ai': {
    api: 'https://api.tonydev.iremedy.ai',
    ws: 'wss://api.tonydev.iremedy.ai',
  },
};

function resolveApiBase(): string {
  if (typeof window !== 'undefined') {
    const match = DOMAIN_API_MAP[window.location.hostname];
    if (match) return match.api;
  }
  return process.env.REACT_APP_API_BASE || '';
}

function resolveWsBase(): string {
  if (typeof window !== 'undefined') {
    const match = DOMAIN_API_MAP[window.location.hostname];
    if (match) return match.ws;
  }
  return process.env.REACT_APP_WS_BASE || '';
}

export const API_BASE = resolveApiBase();
export const WS_BASE = resolveWsBase();
